var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _vm.tab === "long-term-stock" ? _c("longterm-stock") : _vm._e(),
      _vm._v(" "),
      _vm.tab === "product-available" ? _c("product-available") : _vm._e(),
      _vm._v(" "),
      _vm.tab === "fba-product-sales" ? _c("fba-product-sales") : _vm._e(),
      _vm._v(" "),
      _vm.tab === "sales-expansion" ? _c("sales-expansion") : _vm._e(),
      _vm._v(" "),
      _vm.tab === "settings" ? _c("settings") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5da6c082", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da6c082","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/salemonAgent/TabContent.vue
// module id = null
// module chunks = 